import React from 'react';
import { Steps } from 'antd';
import "./SendMoneyPage_new.scss"; 

const { Step } = Steps;

const ProgressBar = ({ current, onStepClick }) => {
  const steps = ["Create", "Recipient", "Details", "Confirm", "Pay"];

  return (
    <div className="progress-bar-container">
      <Steps current={current} className="progress-bar-horizontal">
        {steps.map((step, index) => (
          <Step
            key={index}
            title={step}
            onClick={() => onStepClick(index)}
            disabled={index > current}
            className={`progress-step ${index === current ? 'active-step' : ''}`}
          />
        ))}
      </Steps>
      <div className="mobile-step-indicator">
        <span>{steps[current]}</span>
        <div className="progress-indicator">
          <div className="progress" style={{ width: `${(current / (steps.length - 1)) * 100}%`,  }}></div>
          <div className="progress-dot" style={{ left: `calc(${(current / (steps.length - 1)) * 100}% - 10px)` }}></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;

